import { Config } from "@mediaspace/shared/data-kms-config";
import { RegistrationSectionInfo } from "@mediaspace/shared/types/RegistrationFieldInfo";
import { UserData } from "./RegistrationForm";

export enum RegistrationType {
    NEW = "new",
    EDIT = "edit",
    INVITE = "invite",
}

export interface SiteRegistrationProps {
    fullWidth?: boolean;
    title: string;
    registrationType: RegistrationType;
    userData: UserData;
    sections: RegistrationSectionInfo[];
    titleText: string;
    fieldsMappingToMarketo?: Record<string, string>[];
    marketoResponseTimeout?: number;
    recaptchaSiteKey?: string;
    recaptchaTheme?: "dark" | "light" | undefined;
    recapthcaMode?: "normal" | "invisible" | undefined;
    context: Config;
    action?: string;
    completeTitle: string;
    completeDescriptionHtml: string;
    completeButtonText?: string;
    completeButtonUrl?: string;
    onCompleteScriptContent?: string;
    validateSsoDomains?: boolean;
    registerOtherUser?: boolean;
    onRegistrationCompleted?: () => void;
}
export default SiteRegistrationProps;
